const FAILURE_TIMEOUT = 300000; // 5 minutes

export default FAILURE_TIMEOUT;
